import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap';

const CancelarPage = (props) => {
    const intl = useIntl()
    return (
    <Modal size={'ie'} isOpen={props.open} toggle={props.toggle}>
        <ModalHeader toggle={props.toggle}>
            {props.item.etapa === 1 && <div>{`${intl.formatMessage({ id: "dashboards.histology.cancelBlock" })} ` + props.item.label}</div>}
            {props.item.etapa === 2 && <div>{`${intl.formatMessage({ id: "dashboards.histology.cancelBlade" })} ` + props.item.label}</div> }
        </ModalHeader>
            {props.item.etapa === 1 && <div style={{ marginLeft: '15px', marginTop: '20px'}}>{`${intl.formatMessage({ id: "dashboards.histology.cancelThisBlock" })} `}</div>}
            {props.item.etapa === 2 && <div style={{ marginLeft: '15px', marginTop: '20px'}}>{`${intl.formatMessage({ id: "dashboards.histology.cancelThisBlade" })} `}</div>}
        <ModalFooter>
            <Button color="secondary" onClick={props.toggle}>{`${intl.formatMessage({ id: "general.materialArchiving.close" })} `}</Button>
            <Button color="primary" onClick={props.cancelarItem}>{`${intl.formatMessage({ id: "general.materialArchiving.confirm" })} `}</Button>
        </ModalFooter>
    </Modal>
)}

export default CancelarPage


// WEBPACK FOOTER //
// ./src/pages/histologia/common/modais/cancelar/cancelar.page.js